import { useStoreDispatch } from '@/store/core';
import type { AppDispatch } from '@/store';

/**
 * Dispatch hook
 * Uses the abstraction layer internally
 */
export const useAppDispatch = (): AppDispatch => {
  return useStoreDispatch() as AppDispatch;
};
